/**
 * Formats a phone number string to (###)-###-#### format
 * @param {string} phone - Phone number string (can be digits only or already formatted)
 * @returns {string} - Formatted phone number in (###)-###-#### format
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return "";
  
  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, "");
  
  // If no digits, return empty string
  if (digits.length === 0) return "";
  
  // Format based on length
  if (digits.length <= 3) {
    return `(${digits}`;
  } else if (digits.length <= 6) {
    return `(${digits.slice(0, 3)})-${digits.slice(3)}`;
  } else {
    return `(${digits.slice(0, 3)})-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }
};

/**
 * Cleans a phone number by removing all non-digit characters
 * @param {string} phone - Phone number string (can be formatted or unformatted)
 * @returns {string} - Clean phone number with only digits
 */
export const cleanPhoneNumber = (phone) => {
  if (!phone) return "";
  return phone.replace(/\D/g, "");
};

/**
 * Formats phone number as user types (handles input events)
 * @param {string} value - Current input value
 * @param {string} previousValue - Previous input value
 * @returns {string} - Formatted phone number
 */
export const formatPhoneInput = (value, previousValue = "") => {
  if (!value) return "";
  
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, "");
  
  // Limit to 10 digits
  const limitedDigits = digits.slice(0, 10);
  
  // Format the digits
  return formatPhoneNumber(limitedDigits);
};

